// Image Button for Duplicate.
// Author : Huen Oh (heons921@gmail.com)
// @param {string} name Name of the component. For data-cy.
// @param {string} id   Id of an object which is assigned to the component.

<template>
  <!-- Image button: Duplicate -->
  <a :data-cy="`${name}-btn-duplicate`" href="javascript:void(0);">
    <b-img 
      :id="'duplicate-'+id" 
      class="no-checkbox cls-img-btn ml-2" 
      src="/assets/icons/duplicate_use.svg" 
      @click="onClick"
    />
    <b-tooltip :target="'duplicate-'+id" placement="bottom" :title="$t('tool-tips.duplicate')"></b-tooltip>
  </a>
</template>


<script>
export default {
  props:{
    // {string} Name of the component. For data-cy.
    name: {
      type: String,
      default: ""
    },
    // {string} Id of an object which is assigned to the component.
    id: {
      type: String,
      default: ""
    },
  },
  methods:{
    /**
     * On click the button.
     */
    onClick() {
      this.$emit('click');
    }
  }
}
</script>
<style src="@/assets/css/sass/style_custom.scss" lang="scss" scoped></style>
              